import { Component, Injectable } from '@angular/core';
import { NgRedux } from '@angular-redux/store';
import { SelectedVehicleActions } from './selected-vehicle-actions';
import { DispatcherModule } from '../dispatcher.module';
import { AppState } from '../state.model';
import { Vehicle } from '../../admin/models/vehicles/vehicle';

@Injectable({
  providedIn: DispatcherModule
})
export class SelectedVehicleDispatcher {
  constructor(
    private ngRedux: NgRedux<AppState>
  ) { }
  /**
  * setSelectedVehicle Store the vehicleDetails
  * @param vehicle vehicleDetails  from the vehicle payload
  **/
  setSelectedVehicle(vehicle: object) {
    this.ngRedux.dispatch(SelectedVehicleActions.setSelectedVehicle(vehicle));
  }
  /**
   * resetSelectedVehicleStore reset the store
   **/
  resetSelectedVehicleStore() {
    this.ngRedux.dispatch(SelectedVehicleActions.resetSelectedVehicleStore());
  }
}
